<ng-container>
  <form
    [formGroup]="eventsBrowseService.browseForm"
    class="form --inline --centered events-browse-form my-4 px-4"
    [class]="{
      'additional-field': !eventsBrowseService.organizer && !eventsBrowseService.disableMap
    }"
    >
    <app-text-form-field
      class="form__field --large mx-0"
      [class]="{
        'custom-element-on-background-color': oldWidget
      }"
      [form]="eventsBrowseService.browseForm"
      [controlName]="'searchQuery'"
      [formModel]="eventsBrowseService.browseModel"
      [options]="{
        label: 'events.searchEvent',
        hint: 'events.searchByEventName',
        iconName: 'search'
      }"
    />

    <app-select-form-field
      class="form__field mx-0 events-browse-form__small-field"
      [class]="{
        '--additional-field': !eventsBrowseService.organizer && !eventsBrowseService.disableMap,
        'custom-element-on-background-color': oldWidget
      }"
      [selections]="eventsBrowseService.sortOptions"
      [form]="eventsBrowseService.browseForm"
      [controlName]="'sort'"
      [formModel]="eventsBrowseService.browseModel"
      [validators]="[]"
      [options]="{
        label: 'form.sortBy'
      }"
    />

    @if (!eventsBrowseService.organizer && !eventsBrowseService.disableMap) {
      <app-select-form-field
        class="form__field mx-0 custom-element-on-background-color events-browse-form__small-field"
      [class]="{
        'additional-field': !eventsBrowseService.organizer && !eventsBrowseService.disableMap,
        'custom-element-on-background-color': oldWidget
      }"
        [selections]="eventsBrowseService.displayOptions"
        [form]="eventsBrowseService.browseForm"
        [controlName]="'displayStyle'"
        [formModel]="eventsBrowseService.browseModel"
        [validators]="[]"
      [options]="{
        label: 'form.display'
      }"
      />
    }

  </form>

  <router-outlet/>

</ng-container>
